import { User } from '@klubovna/shared-models';

export interface UserState {
  user: User | null;
  loading: boolean;
  error: string | null;
  isAuthenticated: boolean;
  updateProfileLoading: boolean;
  updateProfileError: string | null;
  photoUploading: boolean;
  photoDeleting: boolean;
}

export const initialUserState: UserState = {
  user: null,
  loading: false,
  error: null,
  isAuthenticated: false,
  updateProfileLoading: false,
  updateProfileError: null,
  photoUploading: false,
  photoDeleting: false,
};
